import { MODAL } from '../../../utils/constants.json';

/**
 * action -close modal and dispatch success actions.
 * @param {string} content context body of modal
 * @param {string} title title of modal
 * @param {string} type title of modal
 * @param {string} cBtn title of modal
 * @param {string} sBtn title of modal
 * @param {string} width title of modal
 * @param {string} contentType title of modal
 * @param {string} aType title of modal
 * @param {string} sbtnAction title of modal
 * @param {string} cbtnAction title of modal
 * @return {object}
 */
export function openViewDefaultModal(
  content,
  title,
  type,
  cBtn,
  sBtn,
  width,
  contentType,
  aType,
  sbtnAction,
  cbtnAction,
) {
  return {
    type: aType || MODAL.OPEN_DEFAULT_MODAL,
    payload: {
      content,
      title,
      type,
      cBtn,
      sBtn,
      width,
      contentType,
      aType,
      sbtnAction,
      cbtnAction,
    },
  };
}
/**
 * action -close modal and dispatch success actions.
 * @param {string} aType title of modal
 * @return {object}
 */
export function closeViewDefaultModal(aType) {
  return {
    type: aType || MODAL.CLOSE_DEFAULT_MODAL,
    payload: { content: '', title: '' },
  };
}
